module.exports = __webpack_public_path__ + "static/media/lr.6656f943.svg";